<script lang="ts">
import PrizeCard from '@/components/cards/PrizeCard.vue'
import type {
  FilterFunctionProperties,
  InstantWinMainPrize,
  Prize,
} from '@/types'
import { isInstantWinMainPrize, isPrize } from '@/utils/type-guard-utils'
import { type PropType, defineComponent } from 'vue'

import InstantWinDrawCard from '../cards/InstantWinDrawCard.vue'
import AppCarousel from '../carousel/AppCarousel.vue'
import CarouselItem from '../carousel/CarouselItem.vue'

export default defineComponent({
  components: {
    PrizeCard,
    InstantWinDrawCard,
    AppCarousel,
    CarouselItem,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    filter: {
      type: Object as PropType<
        FilterFunctionProperties<Prize | InstantWinMainPrize, true>
      >,
    },
    prizes: {
      type: Array as () => (Prize | InstantWinMainPrize)[],
    },
  },
  setup() {
    return {
      isInstantWinMainPrize,
      isPrize,
    }
  },
  data() {
    return {
      currentPrizeTab: 0,
    }
  },
  computed: {
    prizesArray() {
      return this.filter?.filteredItems.value ?? this.prizes ?? []
    },
  },
  async mounted() {
    await this.filter?.loadItems()
  },
  methods: {
    handleFilterUpdate(index: number) {
      if (this.currentPrizeTab === index) {
        return
      }
      this.currentPrizeTab = index
    },
  },
})
</script>

<template>
  <AppSection>
    <slot name="heading" />

    <slot name="sub-heading" />

    <AppFilter v-if="filter" :id :filter @update-filter="handleFilterUpdate" />

    <AppCarousel
      ref="prizesSlider"
      slider-id="prizes-slider"
      :title="filter?.selectedItemCode.value || ''"
    >
      <CarouselItem
        v-for="(prize, key) in prizesArray"
        :key="`${prize.code}-${key}`"
        class="w-full @xs/main:w-1/2 @md/main:w-1/3 @lg/main:w-1/4"
      >
        <InstantWinDrawCard v-if="isInstantWinMainPrize(prize)" :prize />

        <PrizeCard v-if="isPrize(prize)" :prize>
          <template #button="{ prize }">
            <slot name="prizeButton" :prize />
          </template>
        </PrizeCard>
      </CarouselItem>
    </AppCarousel>
    <slot name="button" />
  </AppSection>
</template>
